import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import PermissionProvider from 'src/utils/PermissionProvider';
import { isAdmin } from 'src/utils';

function ProtectedComponent({ component: Component, permission, children, ...rest }) {
	const userPermissions = useContext(PermissionProvider);
	let isVisible = false;
	isVisible = userPermissions?.some((el) => el.value === permission);
	const admin = isAdmin() && permission === 'Admin';

	if (permission instanceof Array) {
		isVisible = userPermissions?.some((el) => permission?.some((item) => el.value === item));
	}

	if (!(isVisible || permission === 'all' || admin)) {
		return null;
	}

	// Prefer children so callers can keep a stable element tree. Passing an inline
	// `component={() => ...}` remounts on every parent render and resets local state.
	if (children != null) {
		return children;
	}

	return Component ? <Component {...rest} /> : null;
}

ProtectedComponent.propTypes = {
	children: PropTypes.node,
	component: PropTypes.func,
	permission: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};

export default ProtectedComponent;
